<template>
  <div>
    <headerNav></headerNav>
    <div class="contain">
      <div class="left-box">
        <leftNav v-if="this.$route.path !== '/home'"></leftNav>
      </div>
      <div class="right-box">
        <breadNav v-if="this.$route.path !== '/home'"></breadNav>
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
    <footerNav></footerNav>
  </div>
</template>
<script>
import { headerNav, footerNav, leftNav, breadNav } from "./components";

export default {
  components: {
    headerNav,
    footerNav,
    leftNav,
    breadNav
  },
  data () {
    return {
      routeList: []
    }
  },
  created () {
    // this.$router.beforeEach((to,from)=>{
    //   console.log(to,from)
    // })
  },
  watch: {
    // $route(to, from){
    //   console.log(to, from)
    //   this.routeList =  from.matched
    // }
  }
};
</script>
<style lang="scss" scoped>
.right-box {
  width: 100%;
  min-height: 81vh;
}
.contain {
  width: 1000px;
  margin: auto;
  display: flex;
  padding-bottom: 0.5rem;
  background: #fff;
  // padding: 0 0.2rem;
}
</style>